import React from 'react'
import PropTypes from 'prop-types'
import config from 'config'

import { Row, Col, Text, Margin } from 'shared/components'

import {
  convertTimeToTimeZone,
  getUtcTextTimeZone,
  getTimeZone,
} from './helper'
import * as styles from './styles'

export const TeamsPlayersComponent = ({
  teamOne,
  teamTwo,
  startTime,
  tournament,
  matchName,
}) => {
  // Check if this is a custom event (no teams)
  const isCustomEvent = !teamOne || !teamTwo;

  return (
    <Row xs={12} sm={12} css={styles.mainWrapper}>
      <Col xs={12} sm={3} css={styles.wrapperColumn}>
        <Row css={styles.wrapperRowCenter} xs={12}>
          <img
            src={`${config.assets.baseUrl}${tournament.logo}`}
            width="48"
            height="48"
            alt="tournament logo"
          />
          {!isCustomEvent && (
            <Text xs={12} css={[styles.textStyles, { marginLeft: 8 }]}>
              {(tournament.tournamentName ?? '').substring(0, 3)}
            </Text>
          )}
        </Row>
      </Col>

      <Col xs={12} sm={4} css={styles.wrapperColumn}>
        {isCustomEvent ? (
          <Row css={styles.wrapperRowCenter} xs={12}>
            <Text css={styles.textStyles}>
              {matchName || (tournament.sportType === 'athletics' ? 'Athletics Event' : 'Custom Event')}
            </Text>
          </Row>
        ) : (
          <Row css={styles.wrapperRowCenter} xs={12}>
            <Col xs={4} sm={4}>
              <Row css={styles.wrapperRowCenter} xs={12}>
                <img
                  src={`${config.assets.baseUrl}${teamOne.logo}`}
                  width="64"
                  height="64"
                  alt="logo team one"
                />
              </Row>
              <Row css={styles.wrapperRowCenter}>
                <Text xs={12} css={styles.textStyles}>
                  {teamOne.teamName}
                </Text>
              </Row>
            </Col>
            <Col xs={4} sm={4}>
              <Row css={styles.wrapperRowCenter}>
                <Margin bottom={3} top={3}>
                  <Text gray xs={12} css={styles.textStyles}>
                    VS
                  </Text>
                </Margin>
              </Row>
            </Col>
            <Col xs={4} sm={4}>
              <Row css={styles.wrapperRowCenter} xs={12}>
                <img
                  src={`${config.assets.baseUrl}${teamTwo.logo}`}
                  width="64"
                  height="64"
                  alt="logo team two"
                />
              </Row>
              <Row css={styles.wrapperRowCenter} xs={12}>
                <Text css={styles.textStyles}>{teamTwo.teamName}</Text>
              </Row>
            </Col>
          </Row>
        )}
      </Col>

      <Col xs={12} sm={2} css={styles.wrapperColumn}>
        <Row css={styles.wrapperRowCenter}>
          <Text css={styles.textStyles}>
            {convertTimeToTimeZone(startTime, getTimeZone(), 'MMM dd , yyyy')}
          </Text>
        </Row>
      </Col>
      <Col xs={12} sm={3} css={styles.wrapperColumn}>
        <Row css={styles.wrapperTimeZoneText} xs={12}>
          <Text gray css={styles.textStyles}>
            {getUtcTextTimeZone()}
          </Text>
        </Row>

        <Row css={styles.wrapperRowCenter}>
          <Text css={styles.textStyles}>
            {convertTimeToTimeZone(startTime, getTimeZone(), 'HH:mm a')}
          </Text>
        </Row>
      </Col>
    </Row>
  );
}

TeamsPlayersComponent.propTypes = {
  teamOne: PropTypes.shape(),
  teamTwo: PropTypes.shape(),
  startTime: PropTypes.string.isRequired,
  tournament: PropTypes.shape({
    logo: PropTypes.string,
    tournamentName: PropTypes.string,
    sportType: PropTypes.string,
  }).isRequired,
  matchName: PropTypes.string,
}
